import React, { useEffect, useRef, useState, useCallback } from "react";
import { classNames } from "primereact/utils";
import { Route, Routes } from "react-router-dom";
import { useLocation, useNavigate } from "react-router-dom";
import AppTopbar from "./AppTopbar";
import AppInlineMenu from "./AppInlineMenu";
import AppMenu from "./AppMenu";
import AppConfig from "./AppConfig";
import AppRightMenu from "./AppRightMenu";
import Login from "./pages/Login";
import EmptyPage from "./pages/EmptyPage";
import Tablero from "./pages/Tablero";
import Factura from "./features/documento/factura/Factura";
import Boleta from "./features/documento/boleta/Boleta";
import Cotizacion from "./features/cotizacion/Cotizacion";
import Sincronizacion from "./features/sincronizacion/Sincronizacion";
import PrimeReact, { addLocale, locale } from "primereact/api";
import { Tooltip } from "primereact/tooltip";
import "primereact/resources/primereact.min.css";
import "primeicons/primeicons.css";
import "primeflex/primeflex.css";
import "./App.scss";
import AppContext from "./Config";
import { useGlobalContext } from "./Config";
import { loginService } from "./service/AffariService";

export const RTLContext = React.createContext();

addLocale('es', {
    firstDayOfWeek: 1,
    dayNames: ['domingo', 'lunes', 'martes', 'miércoles', 'jueves', 'viernes', 'sábado'],
    dayNamesShort: ['dom', 'lun', 'mar', 'mié', 'jue', 'vie', 'sáb'],
    dayNamesMin: ['D', 'L', 'M', 'X', 'J', 'V', 'S'],
    monthNames: ['enero', 'febrero', 'marzo', 'abril', 'mayo', 'junio', 'julio', 'agosto', 'septiembre', 'octubre', 'noviembre', 'diciembre'],
    monthNamesShort: ['ene', 'feb', 'mar', 'abr', 'may', 'jun', 'jul', 'ago', 'sep', 'oct', 'nov', 'dic'],
    today: 'Hoy',
    clear: 'Limpiar',
    startsWith: 'Comienza con',
    contains: 'Contiene',
    notContains: 'No contiene',
    endsWith: 'Termina con',
    equals: 'Igual a',
    notEquals: 'Diferente de',
    noFilter: 'Sin filtro',
    lt: 'Menor que',
    lte: 'Menor o igual a',
    gt: 'Mayor que',
    gte: 'Mayor o igual a',
    dateIs: 'Fecha igual a',
    dateIsNot: 'Fecha diferente a',
    dateBefore: 'Fecha antes de',
    dateAfter: 'Fecha después de',
    custom: 'Personalizado',
    apply: 'Aplicar',
    matchAll: 'Coincidir todo',
    matchAny: 'Coincidir cualquiera',
    addRule: 'Agregar regla',
    removeRule: 'Eliminar regla',
    accept: 'Sí',
    reject: 'No',
    choose: 'Escoger',
    upload: 'Subir',
    cancel: 'Cancelar',
    fileSizeTypes: ['B', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'],
    emptyMessage: 'No se encontraron resultados',
    emptyFilterMessage: 'No se encontraron resultados'
});

locale('es');

const App = () => {
  const [menuMode, setMenuMode] = useState("static");
  const [inlineMenuPosition, setInlineMenuPosition] = useState("bottom");
  const [desktopMenuActive, setDesktopMenuActive] = useState(false); // Changed from true to false
  const [mobileMenuActive, setMobileMenuActive] = useState(false);
  const [activeTopbarItem, setActiveTopbarItem] = useState(null);
  const [colorMode, setColorMode] = useState("light");
  const [rightMenuActive, setRightMenuActive] = useState(false);
  const [menuActive, setMenuActive] = useState(false);
  const [inputStyle, setInputStyle] = useState("outlined");
  const [isRTL, setRTL] = useState(false);
  const [ripple, setRipple] = useState(true);
  const [mobileTopbarActive, setMobileTopbarActive] = useState(false);
  const [menuTheme, setMenuTheme] = useState("light");
  const [topbarTheme, setTopbarTheme] = useState("blue");
  const [theme, setTheme] = useState("indigo");
  const [isInputBackgroundChanged, setIsInputBackgroundChanged] = useState(false);
  const [inlineMenuActive, setInlineMenuActive] = useState({});
  const [newThemeLoaded, setNewThemeLoaded] = useState(false);
  const [searchActive, setSearchActive] = useState(false);
  const { setIsLoggedIn } = useGlobalContext();
  const { baseUrl } = useGlobalContext();
  const copyTooltipRef = useRef();
  let currentInlineMenuKey = useRef(null);
  const location = useLocation();
  const navigate = useNavigate();
  const isSincronizacionRoute = location.pathname === "/sincronizacion";

  let searchClick;
  let topbarItemClick;
  let menuClick;
  let inlineMenuClick;

  var customMenu = [];
  customMenu[0] = {
    label: "Menú Principal",
    icon: "pi pi-fw pi-list",
    items: [],
  };

  if (sessionStorage.getItem("param1") === "true" || true) {
    customMenu[0]["items"].push(

      {
        label: "Tablero",
        icon: "pi pi-fw pi-book",
        to: "/tablero",
      },
      {
        label: "Ingresar Cotización",
        icon: "pi pi-fw pi-list",
        items: [
          {
            label: "Boleta",
            icon: "pi pi-fw pi-list",
            to: "/boleta",
          },
          {
            label: "Factura",
            icon: "pi pi-fw pi-list",
            to: "/factura",
          },
        ],
      },
      {
        label: "Lista de Cotizaciones",
        icon: "pi pi-fw pi-book",
        to: "/cotizaciones",
      },
      {
        label: "Reportes",
        icon: "pi pi-fw pi-book",
        to: "/reportes",
      },

      {
        label: "Mantenedores",
        icon: "pi pi-fw pi-list",
        items: [
          {
            label: "Competencias",
            icon: "pi pi-fw pi-list",
            to: "/competencias",
          },
          {
            label: "Causas de Pérdida",
            icon: "pi pi-fw pi-list",
            to: "/causas-perdida",
          },
          {
            label: "Cierres de Cotización",
            icon: "pi pi-fw pi-list",
            to: "/cierres-cotizacion",
          },
          {
            label: "Estados",
            icon: "pi pi-fw pi-list",
            to: "/estados",
          },
          {
            label: "Usuarios",
            icon: "pi pi-fw pi-list",
            to: "/usuarios",
          },
          {
            label: "Constantes P.E.",
            icon: "pi pi-fw pi-list",
            to: "/constantes-pe",
          },
          {
            label: "Materia Prima P.E.",
            icon: "pi pi-fw pi-list",
            to: "/materia-prima-pe",
          },
          {
            label: "Servicio de Armado P.E.",
            icon: "pi pi-fw pi-list",
            to: "/servicio-armado-pe",
          },
          {
            label: "Servicio de Corte P.E.",
            icon: "pi pi-fw pi-list",
            to: "/servicio-corte-pe",
          },
          {
            label: "Servicio de Perforacion P.E.",
            icon: "pi pi-fw pi-list",
            to: "/servicio-perforacion-pe",
          },
        ],
      }
    );
  }

  if (sessionStorage.getItem("perfil") === 1) {
    customMenu[0]["items"].push({
      label: "Administración",
      icon: "pi pi-fw pi-list",
      items: [
        {
          label: "Usuarios",
          icon: "pi pi-fw pi-list",
          to: "/usuarios",
        },
      ],
    });
  }

  if (sessionStorage.getItem("perfil") === 2) {
  }

  const menu = customMenu;

  useEffect(() => {
    copyTooltipRef &&
      copyTooltipRef.current &&
      copyTooltipRef.current.updateTargetEvents();
  }, [location]);

  useEffect(() => {
    if (menuMode === "overlay") {
      hideOverlayMenu();
    }
    /*if (menuMode === "static") {
      setDesktopMenuActive(true);
    }*/
  }, [menuMode]);

  const onMenuThemeChange = (theme) => {
    setMenuTheme(theme);
  };

  const onTopbarThemeChange = (theme) => {
    setTopbarTheme(theme);
  };

  const replaceLink = useCallback((linkElement, href, callback) => {
    if (isIE()) {
      linkElement.setAttribute("href", href);

      if (callback) {
        callback();
      }
    } else {
      const id = linkElement.getAttribute("id");
      const cloneLinkElement = linkElement.cloneNode(true);

      cloneLinkElement.setAttribute("href", href);
      cloneLinkElement.setAttribute("id", id + "-clone");

      linkElement.parentNode.insertBefore(
        cloneLinkElement,
        linkElement.nextSibling
      );

      cloneLinkElement.addEventListener("load", () => {
        linkElement.remove();
        const _linkElement = document.getElementById(id);
        _linkElement && _linkElement.remove();
        cloneLinkElement.setAttribute("id", id);
        if (callback) {
          callback();
        }
      });
    }
  }, []);

  const onThemeChange = (theme) => {
    setTheme(theme);
    const themeLink = document.getElementById("theme-css");
    const themeHref = "assets/theme/" + theme + "/theme-" + colorMode + ".css";
    replaceLink(themeLink, themeHref);
  };

  const onColorModeChange = useCallback((mode) => {
    setColorMode(mode);
    setIsInputBackgroundChanged(true);

    if (isInputBackgroundChanged) {
      if (mode === "dark") {
        setInputStyle("filled");
      } else {
        setInputStyle("outlined");
      }
    }

    if (mode === "dark") {
      setMenuTheme("dark");
      setTopbarTheme("dark");
    } else {
      setMenuTheme("light");
      setTopbarTheme("blue");
    }

    const layoutLink = document.getElementById("layout-css");
    const layoutHref = "assets/layout/css/layout-" + mode + ".css";
    replaceLink(layoutLink, layoutHref);

    const themeLink = document.getElementById("theme-css");
    const urlTokens = themeLink.getAttribute("href").split("/");
    urlTokens[urlTokens.length - 1] = "theme-" + mode + ".css";
    const newURL = urlTokens.join("/");

    replaceLink(themeLink, newURL, () => {
      setNewThemeLoaded(true);
    });
  }, [isInputBackgroundChanged, replaceLink]);

  const onInputStyleChange = (inputStyle) => {
    setInputStyle(inputStyle);
  };

  const onRipple = (e) => {
    PrimeReact.ripple = e.value;
    setRipple(e.value);
  };

  const onInlineMenuPositionChange = (mode) => {
    setInlineMenuPosition(mode);
  };

  const onMenuModeChange = (mode) => {
    setMenuMode(mode);
  };

  const onRTLChange = () => {
    setRTL((prevState) => !prevState);
  };

  const onMenuClick = (event) => {
    menuClick = true;
  };

  const onMenuButtonClick = (event) => {
    menuClick = true;

    if (isDesktop()) {
      //setDesktopMenuActive((prevState) => !prevState);
    } else {
      setMobileMenuActive((prevState) => !prevState);
    }

    event.preventDefault();
  };

  const onTopbarItemClick = (event) => {
    topbarItemClick = true;
    if (activeTopbarItem === event.item) setActiveTopbarItem(null);
    else {
      setActiveTopbarItem(event.item);
    }

    event.originalEvent.preventDefault();
  };

  const onSearch = (event) => {
    searchClick = true;
    setSearchActive(event);
  };

  const onMenuItemClick = (event) => {
    if (!event.item.items && (menuMode === "overlay" || !isDesktop())) {
      hideOverlayMenu();
    }

    if (!event.item.items && (isHorizontal() || isSlim())) {
      setMenuActive(false);
    }
  };

  const onRootMenuItemClick = (event) => {
    setMenuActive((prevState) => !prevState);
  };

  const onRightMenuButtonClick = () => {
    setRightMenuActive((prevState) => !prevState);
  };

  const onMobileTopbarButtonClick = (event) => {
    setMobileTopbarActive((prevState) => !prevState);
    event.preventDefault();
  };

  const onDocumentClick = (event) => {
    if (!searchClick && event.target.localName !== "input") {
      setSearchActive(false);
    }

    if (!topbarItemClick) {
      setActiveTopbarItem(null);
    }

    if (!menuClick && (menuMode === "overlay" || !isDesktop())) {
      if (isHorizontal() || isSlim()) {
        setMenuActive(false);
      }
      hideOverlayMenu();
    }

    if (inlineMenuActive[currentInlineMenuKey.current] && !inlineMenuClick) {
      let menuKeys = { ...inlineMenuActive };
      menuKeys[currentInlineMenuKey.current] = false;
      setInlineMenuActive(menuKeys);
    }

    if (!menuClick && (isSlim() || isHorizontal())) {
      setMenuActive(false);
    }

    searchClick = false;
    topbarItemClick = false;
    inlineMenuClick = false;
    menuClick = false;
  };

  const hideOverlayMenu = () => {
    setMobileMenuActive(false);
    setDesktopMenuActive(false);
  };

  const isDesktop = () => {
    return window.innerWidth > 1024;
  };

  const isHorizontal = () => {
    return menuMode === "horizontal";
  };

  const isSlim = () => {
    return menuMode === "slim";
  };

  const isIE = () => {
    return /(MSIE|Trident\/|Edge\/)/i.test(window.navigator.userAgent);
  };

  const onInlineMenuClick = (e, key) => {
    let menuKeys = { ...inlineMenuActive };
    if (key !== currentInlineMenuKey.current && currentInlineMenuKey.current) {
      menuKeys[currentInlineMenuKey.current] = false;
    }

    menuKeys[key] = !menuKeys[key];
    setInlineMenuActive(menuKeys);
    currentInlineMenuKey.current = key;
    inlineMenuClick = true;
  };

  const layoutContainerClassName = classNames(
    "layout-wrapper ",
    "layout-menu-" + menuTheme + " layout-topbar-" + topbarTheme,
    {
      "layout-menu-static": menuMode === "static",
      "layout-menu-overlay": menuMode === "overlay",
      "layout-menu-slim": menuMode === "slim",
      "layout-menu-horizontal": menuMode === "horizontal",
      "layout-menu-active": desktopMenuActive,
      "layout-menu-mobile-active": mobileMenuActive,
      "layout-topbar-mobile-active": mobileTopbarActive,
      "layout-rightmenu-active": rightMenuActive,
      "p-input-filled": inputStyle === "filled",
      "p-ripple-disabled": !ripple,
      "layout-rtl": isRTL,
    }
  );

  const handleLogin = (username, password) => {
    const checkLogin = async () => {
      if (!username || !password) {
        alert("Complete todos los campos");
        return;
      }
      try {
        await loginService(username, password);

        sessionStorage.setItem("authUsername", username);
        sessionStorage.setItem("authPassword", password);
        sessionStorage.setItem("isLoggedIn", "true");
        setIsLoggedIn(true);
        navigate("/tablero");
      } catch (error) {
        console.error("Error durante la autenticación:", error);
        alert("Usuario No Autorizado");
      }
    };

    checkLogin();
  };

  const isLoggedInStorage = sessionStorage.getItem("isLoggedIn") === "true";
  const isPublicSincronizacion = location.pathname === "/sincronizacion";

  if (!isLoggedInStorage && !isPublicSincronizacion) {
    return (
      <Login
        colorMode="light"
        isNewThemeLoaded={false}
        onNewThemeChange={() => {}}
        location={location}
        handleLogin={handleLogin}
      />
    );
  }

  return (
    <RTLContext.Provider value={isRTL}>
      <AppContext>
        {" "}
        <div className={layoutContainerClassName} onClick={onDocumentClick}>
          <Tooltip
            ref={copyTooltipRef}
            target=".block-action-copy"
            position="bottom"
            content="Copied to clipboard"
            event="focus"
          />

          {!isSincronizacionRoute && (
            <AppTopbar
              horizontal={isHorizontal()}
              activeTopbarItem={activeTopbarItem}
              onMenuButtonClick={onMenuButtonClick}
              onTopbarItemClick={onTopbarItemClick}
              onRightMenuButtonClick={onRightMenuButtonClick}
              onMobileTopbarButtonClick={onMobileTopbarButtonClick}
              mobileTopbarActive={mobileTopbarActive}
              searchActive={searchActive}
              onSearch={onSearch}
              clientId={sessionStorage.getItem("clientId")}
              menu={menu}
              handleLogin={handleLogin}
              colorMode={colorMode}
              onColorModeChange={onColorModeChange}
            />
          )}
          {(() => {
            if (isLoggedInStorage) {
              return (
                <>
                  <div className="menu-wrapper" onClick={onMenuClick}>
                    <div className="layout-menu-container">
                      {(inlineMenuPosition === "top" ||
                        inlineMenuPosition === "both") && (
                        <AppInlineMenu
                          menuKey="top"
                          inlineMenuActive={inlineMenuActive}
                          onInlineMenuClick={onInlineMenuClick}
                          horizontal={isHorizontal()}
                          menuMode={menuMode}
                        />
                      )}
                      <AppMenu
                        model={menu}
                        onMenuItemClick={onMenuItemClick}
                        onRootMenuItemClick={onRootMenuItemClick}
                        menuMode={menuMode}
                        active={menuActive}
                      />
                    </div>
                  </div>
                </>
              );
            }
          })()}

          <div className="layout-main">
            <div className="layout-content">
              <Routes>
                <Route path="/" element={<EmptyPage />} location={location} />

                <Route
                  path="/tablero"
                  element={
                    <Tablero
                      colorMode={colorMode}
                      isNewThemeLoaded={newThemeLoaded}
                      onNewThemeChange={(e) => setNewThemeLoaded(e)}
                      location={location}
                      proveedor={sessionStorage.getItem("proveedor")}
                      perfil={sessionStorage.getItem("perfil")}
                    />
                  }
                />
                <Route
                  path="/factura"
                  element={
                    <Factura
                      colorMode={colorMode}
                      isNewThemeLoaded={newThemeLoaded}
                      onNewThemeChange={(e) => setNewThemeLoaded(e)}
                      location={location}
                      proveedor={sessionStorage.getItem("proveedor")}
                      perfil={sessionStorage.getItem("perfil")}
                    />
                  }
                />
                <Route
                  path="/boleta"
                  element={
                    <Boleta
                      colorMode={colorMode}
                      isNewThemeLoaded={newThemeLoaded}
                      onNewThemeChange={(e) => setNewThemeLoaded(e)}
                      location={location}
                      proveedor={sessionStorage.getItem("proveedor")}
                      perfil={sessionStorage.getItem("perfil")}
                    />
                  }
                />
                <Route
                  path="/cotizacion"
                  element={
                    <Cotizacion
                      colorMode={colorMode}
                      isNewThemeLoaded={newThemeLoaded}
                      onNewThemeChange={(e) => setNewThemeLoaded(e)}
                      location={location}
                      proveedor={sessionStorage.getItem("proveedor")}
                      perfil={sessionStorage.getItem("perfil")}
                    />
                  }
                />

                <Route
                  path="/sincronizacion"
                  element={
                    <Sincronizacion
                      colorMode={colorMode}
                      isNewThemeLoaded={newThemeLoaded}
                      onNewThemeChange={(e) => setNewThemeLoaded(e)}
                      location={location}
                      proveedor={sessionStorage.getItem("proveedor")}
                      perfil={sessionStorage.getItem("perfil")}
                    />
                  }
                />

              </Routes>
            </div>
          </div>

          <AppConfig
            inputStyle={inputStyle}
            onInputStyleChange={onInputStyleChange}
            rippleEffect={ripple}
            onRippleEffect={onRipple}
            menuMode={menuMode}
            onMenuModeChange={onMenuModeChange}
            inlineMenuPosition={inlineMenuPosition}
            onInlineMenuPositionChange={onInlineMenuPositionChange}
            colorMode={colorMode}
            onColorModeChange={onColorModeChange}
            menuTheme={menuTheme}
            onMenuThemeChange={onMenuThemeChange}
            topbarTheme={topbarTheme}
            onTopbarThemeChange={onTopbarThemeChange}
            theme={theme}
            onThemeChange={onThemeChange}
            isRTL={isRTL}
            onRTLChange={onRTLChange}
          />

          <AppRightMenu
            rightMenuActive={rightMenuActive}
            onRightMenuButtonClick={onRightMenuButtonClick}
            display="none"
          />

          {mobileMenuActive && <div className="layout-mask modal-in"></div>}
        </div>
      </AppContext>
    </RTLContext.Provider>
  );
};

export default App;